import { render, staticRenderFns } from "./TenantPage.vue?vue&type=template&id=1d98c19c&"
import script from "./TenantPage.vue?vue&type=script&lang=js&"
export * from "./TenantPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d98c19c')) {
      api.createRecord('1d98c19c', component.options)
    } else {
      api.reload('1d98c19c', component.options)
    }
    module.hot.accept("./TenantPage.vue?vue&type=template&id=1d98c19c&", function () {
      api.rerender('1d98c19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/TenantPage.vue"
export default component.exports